import { ALL_EMPLOYEE_ROUTE_ID, NEW_EMPLOYEE_ROUTE_ID } from './Employee/common';
// import Employee from './Employee';
import EmployeeList from './index';
import CreateEmployee from 'employee/Employee';

export default {
    [NEW_EMPLOYEE_ROUTE_ID]: () => <CreateEmployee />,
    [ALL_EMPLOYEE_ROUTE_ID]: () => <EmployeeList />,
};
